// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class DiagnosisModelResponse {
    static getAttributeTypeMap() {
        return DiagnosisModelResponse.attributeTypeMap;
    }
}
DiagnosisModelResponse.discriminator = undefined;
DiagnosisModelResponse.additionalProperties = false;
DiagnosisModelResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "DiagnosisModel"
    },
];
//# sourceMappingURL=diagnosisModelResponse.js.map